{
  "title": "Sapping Sting",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "Necromancy cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You sap the vitality of one creature you can see in range. The target must succeed on a Constitution saving throw or take 1d4 necrotic damage and fall prone.",
    "At Higher Levels. This spell's damage increases by 1d4 when you reach 5th level (2d4), 11th level (3d4), and 17th level (4d4)."
  ],
  "spellLists": ["eldritch-knight", "arcane-trickster", "wizard"]
}
